import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './StudentSidebar.css';
import { getUser, clearAuth } from '../utils/authUtil';
import { usePopup } from '../context/PopupContext';

const StudentSidebar = ({ mobileOpen, setMobileOpen, isManaged }) => {
  const navigate = useNavigate();
  const { showConfirm } = usePopup();
  const user = getUser();

  const handleLogout = async () => {
    const confirmed = await showConfirm('Logout', 'Are you sure you want to logout?');
    if (confirmed) {
      clearAuth();
      navigate('/');
    }
  };

  const navItems = [
    { path: '/student/dashboard', icon: '▣', label: 'Dashboard' },
    { path: '/student/tests', icon: '📋', label: 'My Tests' },
    { path: '/student/mock', icon: '⚡', label: 'Mock Test' },
    { path: '/student/analytics', icon: '📊', label: 'Analytics' },
    { path: '/student/mistakes', icon: '❌', label: 'Mistake Bank' },
    { path: '/student/ai', icon: '🤖', label: 'AI Assistant' },
    { path: '/student/profile', icon: '👤', label: 'Profile' },
  ];

  return (
    <>
      <div className={`sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo-icon">P</div>
          <span>Zaptude</span>
          <button className="mobile-sidebar-close" onClick={() => setMobileOpen(false)}>×</button>
        </div>

        <div className="sidebar-profile-info">
          <div className="sidebar-avatar">{user?.name?.[0]?.toUpperCase()}</div>
          <div className="sidebar-user-details">
            <div className="sidebar-user-name">{user?.name}</div>
            <div className="sidebar-user-dept">{user?.branch}</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/student/dashboard'}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <button className="sidebar-logout" onClick={handleLogout}>
          <span className="logout-icon">⬡</span> Logout
        </button>
      </div>
    </>
  );
};


export default StudentSidebar;